import { render, staticRenderFns } from "./dicomList.vue?vue&type=template&id=a95930b4&scoped=true"
import script from "./dicomList.vue?vue&type=script&lang=js"
export * from "./dicomList.vue?vue&type=script&lang=js"
import style0 from "./dicomList.vue?vue&type=style&index=0&id=a95930b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95930b4",
  null
  
)

export default component.exports